import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { GetAllClientsNames, UpdateProjectRequest } from 'src/app/model/management-config/projectManagement';
import { ReferenceData } from 'src/app/model/reference-data';
import { User } from 'src/app/model/user';
import { NotificationService } from 'src/app/service/notification.service';
import { ProjectManagementService } from 'src/app/service/projectManagement.service';
import {TestsComponent} from '../../tests/tests.component';
import {Tests} from '../../../model/tests/tests';
import {TestsService} from '../../../service/tests.service';

@Component({
  selector: 'app-edit-project',
  templateUrl: './edit-project.component.html',
  styleUrls: ['./edit-project.component.scss']
})
export class EditProjectComponent implements OnInit {

  @ViewChild(TestsComponent) testsComponent: TestsComponent;

  _projectForm: FormGroup;
  project: UpdateProjectRequest = new UpdateProjectRequest();
  selectedVisitTypes = new FormControl();
  minEndDate = new Date();

  referenceData: ReferenceData;
  clients: GetAllClientsNames[];
  updatedBy: string;
  profile: User = new User;
  email: string;
  tests: Tests;

  visitTypes: Array<Object> =
    [
      { value: 1, name: 'InHome' },
      { value: 2, name: 'InClinic' },
      { value: 3, name: 'Televisit' },
      { value: 4, name: 'Joint Visit' },
    ];

  constructor(private projectService: ProjectManagementService,
              private _formBuilder: FormBuilder,
              private _notificationService: NotificationService,
              private _localStorage: LocalStorageService,
              private testsService: TestsService,
              public dialogRef: MatDialogRef<EditProjectComponent>,
              @Inject(MAT_DIALOG_DATA) public data: UpdateProjectRequest) { }

  ngOnInit(): void {
    this.referenceData = this._localStorage.retrieve('referenceData');
    this.getClients();
    this._projectForm = this._formBuilder.group({

       clientId: new FormControl({ value: this.data.clientId, disabled: false }),
       projectName: new FormControl({ value: this.data.projectName, disabled: false }),
       projectId: new FormControl({ value: this.data.projectId, disabled: false }),
       assessmentType: new FormControl({ value: this.data.assessmentType, disabled: false }),
       maxCallLimit: new FormControl({ value: this.data.maxCallLimit, disabled: false }),
       projectStartDate: new FormControl({ value: this.data.projectStartDate, disabled: false}),
       projectEndDate: new FormControl({ value: this.data.projectEndDate, disabled: false}),
       visitDuration: new FormControl({ value: this.data.visitDuration + '', disabled: false }),
       visitTypes: new FormControl({ value: this.data.visitTypes, disabled: false }),
       projectDesc: new FormControl({ value: this.data.projectDesc, disabled: false }),
       updatedBy: new FormControl({ value: this.data.updatedBy, disabled: false }),

     });

    this.testsService.getProjectTests(this.data.clientId, this.data.projectId).subscribe(
      result => this.tests = result.tests,
      error => console.log(error)
    );
  }

  onSubmit() {
    this.project = this._projectForm.value;
    this.project.tests = this.testsComponent.tests.value;
    this.project.clientId = this.data.clientId;
    this.project.projectId = this.data.projectId;
    this.project.projectName = this.data.projectName;
    this.project.updatedBy = this._localStorage.retrieve('profile').displayName;
    this.projectService.editProjectRequests(this.project)
      .subscribe(data => {
        console.log(data);
        this.dialogRef.close(this._projectForm.value);
        if (data.successFlag){
          this._notificationService.success('Project updated successfully');
          }else{
            this._notificationService.error('Project update failed');
          }
      }, error => console.log(error));
  }

  getClients() {
    this.projectService.getAllClientsNames()
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this.clients = result.clients; 1;
      }, error => console.log(error));
  }
}
